<template>
  <div class="cavitation-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>P &lt; P_v | 气泡爆发与冲击波$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Propeller or Blade segment -->
          <rect x="50" y="80" width="100" height="80" fill="#444" stroke="#888" rx="10" transform="rotate(10, 100, 120)" />
          
          <!-- Liquid flow -->
          <rect width="400" height="240" fill="rgba(34, 166, 179, 0.05)" />

          <!-- Cavitation Bubbles -->
          <g v-for="b in bubbles" :key="b.id">
             <circle :cx="b.x" :cy="b.y" :r="b.r" fill="rgba(255,255,255,0.6)" />
             <!-- Collapse effect -->
             <circle v-if="b.collapsing" :cx="b.x" :cy="b.y" :r="b.r*2" fill="none" stroke="#ff4757" stroke-width="1" opacity="0.6">
                <animate attributeName="r" values="0;20" dur="0.2s" repeatCount="indefinite" />
             </circle>
          </g>

          <!-- Warning text -->
          <text x="60" y="115" fill="#ff4757" font-size="10" v-if="intensity > 60">! 剥蚀风险</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>局部压强: {{ (101 - intensity).toFixed(1) }} kPa</label>
              <div class="value" :style="{color: intensity > 50 ? '#ff4757' : '#2ed573'}">
                 {{ intensity > 50 ? '空化发生 (气泡溃灭)' : '正常流动' }}
              </div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节螺旋桨转速</label>
             <el-slider v-model="intensity" :min="10" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>空化现象是指在流体系统的局部区域，压强因流速太快而降低到液体的饱和蒸汽压以下，导致液体内部发生气化并产生微小气泡的现象。当这些气泡流向高压区时，会发生毁灭性的**溃灭**，并在微观尺度上产生极强的冲击波和金属剥蚀力。这对船舶螺旋桨、水轮机片以及泵的寿命有极大威胁，但在超声波清洗和某些医学治疗中却被巧妙利用。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CavitationViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      intensity: 30,
      bubbles: [],
      timer: null
    }
  },
  methods: {
    update() {
       if (this.intensity > 40 && this.bubbles.length < this.intensity / 2) {
          this.bubbles.push({
             id: Math.random(),
             x: 150 + Math.random() * 20,
             y: 100 + Math.random() * 40,
             r: 1 + Math.random() * 4,
             vx: 2 + Math.random() * 3,
             collapsing: false
          });
       }

       this.bubbles.forEach((b, idx) => {
          b.x += b.vx;
          if (b.x > 250 && !b.collapsing) {
             b.collapsing = true;
             setTimeout(() => { if(this.bubbles[idx]) this.bubbles.splice(idx, 1); }, 200);
          }
          if (b.x > 400) this.bubbles.splice(idx, 1);
       });
       this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.cavitation-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 71, 87, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
